const StatsDigitalIntegrated = ({language , token}) => {
    const newStatsDigitalIframe = "https:" +
    window.process.env.URL_StatsDigital
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_statsDigital_display"
        src={newStatsDigitalIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default StatsDigitalIntegrated